import { render, staticRenderFns } from "./insert-knowledge.vue?vue&type=template&id=7e7af91e&"
import script from "./insert-knowledge.vue?vue&type=script&lang=js&"
export * from "./insert-knowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports